import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { getThinScrollBarRounded } from "../../utils/utilityFunctions/stringUtility";

const WithPortal = ({
  open,
  onClose,
  borderRadius = "8px",
  yAxis = 8,
  xAxis = 0,
  containerRef,
  children,
  showArrow = false,
}) => {
  const [position, setPosition] = useState({});
  const portalRef = useRef(null);

  // Update dropdown position
  const updatePosition = () => {
    if (containerRef?.current) {
      const rect = containerRef.current.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const viewportWidth = window.innerWidth;
      const componentHeight = 300; // Adjust as per dropdown height
      const componentWidth = rect.width; // Match container width

      const fitsBelow = rect.bottom + componentHeight <= viewportHeight;
      const fitsAbove = rect.top - componentHeight > 0;
      const fitsRight = rect.left + componentWidth <= viewportWidth;
      const fitsLeft = rect.right - componentWidth > 0;

      setPosition({
        top: fitsBelow ? rect.bottom + yAxis : undefined,
        bottom: !fitsBelow && fitsAbove ? viewportHeight - rect.top + 5 : undefined,
        left: fitsRight ? rect.left + xAxis : rect.right - componentWidth,
        width: componentWidth,
      });
    }
  };

  useEffect(() => {
    if (open) {
      updatePosition();
      window.addEventListener("resize", updatePosition);
      window.addEventListener("scroll", updatePosition, true);
      window.addEventListener("mousedown", handleOutsideClick);
    }
    return () => {
      window.removeEventListener("resize", updatePosition);
      window.removeEventListener("scroll", updatePosition, true);
      window.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [open]);

  // Close on outside click
  const handleOutsideClick = (e) => {
    if (
      containerRef?.current &&
      !containerRef.current.contains(e.target) &&
      portalRef.current &&
      !portalRef.current.contains(e.target)
    ) {
      onClose();
    }
  };

  if (!open) return null;

  return ReactDOM.createPortal(
    <div
      ref={portalRef}
      className={getThinScrollBarRounded()}
      style={{
        position: "fixed",
        ...position,
        minWidth: "fit-content",
        zIndex: 9999,
        background: "white",
        boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
        borderRadius: borderRadius,
        maxHeight: "300px",
      }}
    >
      {showArrow && <div class="arrow-left "></div>}
      {children}
    </div>,
    document.body
  );
};

export default WithPortal;
